/**
 * Author: Qian.qianchen 2018-11-13
 * discription: 产品管理 微博 微博账号编辑
 */
'use strict';
angular.module('productManageMentShowRssMessageModule', [])
    .controller('productManageMentShowRssMessageCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$validation', function($scope, $modalInstance, modalDialog, item, trsHttpService, $validation) {
        initStatus();

        /**
         * [cancel description] 数据初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = item;
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }, ]);
